export default __webpack_public_path__ + "static/media/463.b7515e69.jpg";